interface WebApp {
  initData: string;
  initDataUnsafe: { user?: { id: number; first_name?: string; username?: string } };
  ready: () => void;
  expand: () => void;
  colorScheme: "light" | "dark";
}

declare global {
  interface Window {
    Telegram?: { WebApp: WebApp };
  }
}

export function initTelegram(): WebApp | null {
  const wa = window.Telegram?.WebApp;
  if (!wa) return null;
  wa.ready();
  wa.expand();
  return wa;
}
